import React from 'react';

import css from './AuszugAtButton.module.scss';

const AuszugAt: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" height={45} viewBox="0 0 29 45">
    <path d="M.673 23.965h15m-15 3.908h15m-15 3.907h15m-15 3.908h15"
          className={css.lines}></path>
    <path d="M29 19.262C29 13.594 24.405 9 18.738 9H5v9.553h14.446V33H29z"
          className={css.blob}></path>
  </svg>
);

export default AuszugAt;
